import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { Vector2ComponentModule } from '@adaptiva/widgets/vector2';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CloudRelayServerActionOverlayComponent } from './cloud-relay-server-action-overlay.component';

@NgModule({
	imports: [
		AlertComponentModule,
		CommonModule,
		ContainerComponentModule,
		DynamicComponentLoaderModule.forChild(CloudRelayServerActionOverlayComponent),
		InputComponentModule,
		LabelComponentModule,
		TextComponentModule,
		Vector2ComponentModule,
	],
	declarations: [CloudRelayServerActionOverlayComponent],
	exports: [CloudRelayServerActionOverlayComponent]
})
export class CloudRelayServerActionOverlayComponentModule {

}
